import React, { Component } from 'react'
import './Welcome.css'

function textToHtml(html)
{
    let arr = html.split(/<br\s*\/?>/i);
    return arr.reduce((el, a) => el.concat(a, <br />), []);
}

class Welcome extends Component {
    render() {
        return (
          <div className="page-header">
            <h1 className="welcome-text-color">{this.props.welcome.title}</h1>
            <div className="welcome-text-color" dangerouslySetInnerHTML={{__html: this.props.welcome.text}} />
          </div>
        )
    }
}

export default Welcome


// WEBPACK FOOTER //
// ./src/components/welcome/Welcome.js